import Immutable from 'seamless-immutable';
import _ from 'lodash';

/**
 * RelativeAccountModel
 */

/**
 * Create an RelativeAccountModel from provided data
 * @param {Object} account - the account as a POJO
 */
function create(account = _defaultAccount) {
  const result = _.clone(account);
  return Immutable(result, { prototype: model });
}

/**
 * Transform a backend accouunt object into a frontend RelativeAccountModel
 * @param {Object} account - backend formatted accountt
 * @returns {Account}
 */
function deserialize(account) {
  const result = _.pick(account, _keys);
  return create(result);
}

/**
 * Transform an RelativeAccountModel into a backend account object
 * @param {Account} account
 * @returns {Object}
 */
function serialize(account) {
  const result = account.asMutable({ deep: true });
  return _.pick(result, _keys);
}

const model = {};

const _keys = ['id', 'name'];
const _defaultAccount = {};

export default {
  create,
  deserialize,
  serialize,
};
